import React from 'react'
import {requestDeleteCompany} from '../../../../../redux/actions/company'
import { useDispatch, useSelector } from 'react-redux'
import { changeCompanyModal } from '../../../../../redux/actions/company'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.company.showModals.deleteSpace)
	
	const companyId = useSelector(state => state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	

    const loading = useSelector(state => state.company.deleteCompany.loading)

	const handleClose = () => {
        dispatch(changeCompanyModal({deleteSpace: false}))
	}

	const clickCancelSubscription = () => {
		dispatch(requestDeleteCompany({companyId: companyId}))
	}

	return(
		<Popup
			onClose={handleClose}
            show={modalState} 
            title="Vil du slette dette foretaket?"
			description="Dersom du sletter foretaket ditt vil abonnementet ditt automatisk avsluttes og all informasjon knyttet til foretaket ditt bli slettet, og du vil ikke ha mulighet til å gjenopprette det."
            buttons={[
                <TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
                <SolidButton color="red" title={!loading ? "Ja, slett foretak":"Sletter.."} icon={loading ? <i className="fas fa-circle-notch fa-spin"></i>:null} onClick={() => clickCancelSubscription()} type="button"/>
            ]}	
		/>
	)
}

export default Index
